var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4 26.6L21.78 18.94C23.2299 16.9169 24.0066 14.489 24 12C24 5.38 18.62 0 12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C14.6 24 16.96 23.18 18.94 21.78L26.6 29.4C26.98 29.8 27.5 30 28 30C28.5 30 29.04 29.82 29.4 29.4C29.5854 29.215 29.7325 28.9952 29.8329 28.7532C29.9332 28.5113 29.9849 28.2519 29.9849 27.99C29.9849 27.7281 29.9332 27.4687 29.8329 27.2268C29.7325 26.9848 29.5854 26.765 29.4 26.58V26.6ZM12 21.4C6.82 21.4 2.6 17.18 2.6 12C2.6 6.82 6.82 2.6 12 2.6C17.18 2.6 21.4 6.82 21.4 12C21.4 17.18 17.18 21.4 12 21.4Z",
    fill: "#00008E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNew);
export default __webpack_public_path__ + "static/media/search-new.8cf7caa0c53a1f6cb38e7d06de474793.svg";
export { ForwardRef as ReactComponent };